import React from "react";
import { CarouselProvider, Slide, Slider } from "pure-react-carousel";

import { useTranslation } from "react-i18next";
import Row from "components/Row";
import Icon from "components/Icon";
import Column from "components/Column";
import { Text, TextDescription } from "components/Texts";
import Section from "components/Section";
import TextSubscript from "components/TextSubscript";

import useWindowSize from "layout/useWindowSize";

import colors from "styles/colors";

const PerformanceSummary = ({ performanceInfo }) => {
  console.log("performanceInfo", performanceInfo);
  const isMobile = useWindowSize().width < 768;

  if (isMobile)
    return (
      // <CarouselProvider
      //   naturalSlideWidth={55.25}
      //   naturalSlideHeight={101}
      //   totalSlides={performanceInfo.length}
      //   isIntrinsicHeight={true}
      //   visibleSlides={1}
      //   className="performance-summary"
      // >
      //   <Slider trayTag="div" classNameTray="slider-tray">
      //     {
      //       performanceInfo.map((item, index) => (
      //         <Slide key={index} index={index} tag="div">
      //           <PerformanceSummaryItem title={item.title} value={item.value}
      //             change={item.change} icon={item.icon} unit={item.unit} />
      //         </Slide>
      //       ))
      //     }
      //   </Slider>
      // </CarouselProvider>
      <div className="performance-summary">
        {performanceInfo.map((item, index) => (
          <PerformanceSummaryItem
            key={index}
            title={item.title}
            value={item.value}
            change={item.change}
            icon={item.icon}
            unit={item.unit}
          />
        ))}
      </div>
    );
  else
    return (
      <div className="performance-summary">
        {performanceInfo.map((item, index) => (
          <PerformanceSummaryItem
            key={index}
            title={item.title}
            value={item.value}
            change={item.change}
            icon={item.icon}
            unit={item.unit}
          />
        ))}
      </div>
    );
};

const PerformanceSummaryItem = ({ title, value, unit, change, icon }) => {
  const [t] = useTranslation();
  const isMobile = useWindowSize().width < 768;
  const isNoData = value === "-";
  return (
    <Section className="item">
      {isNoData ? (
        <Row alignItems="center">
          <Icon name={icon} size="32px" color={colors.descriptionText} />
          <TextDescription>{t("__no_data")}</TextDescription>
        </Row>
      ) : (
        <Row className="content" columnSpacing="8px" responsive>
          <Column wrap>
            <Icon name={icon} size="32px" color={colors.primary} />
          </Column>
          <Column>
            <TextSubscript
              valueText={value}
              valueSize="24px"
              subscriptSize="10px"
              subscriptText={unit}
              align={isMobile ? "center" : "center"}
            />
            {change === "N/A" ? (
              <Text size="12px" align="center" color="#A8A8A8">
                N/A
              </Text>
            ) : (
              <Text
                size="12px"
                align="center"
                color={
                  change.indexOf("+") > -1
                    ? colors.positive
                    : change.indexOf("%") > -1 && change !== "0%"
                      ? colors.negative
                      : ""
                }
              >
                {change}
              </Text>
            )}
          </Column>
        </Row>
      )}
      <Text color="#999999" className="title">
        {title}
      </Text>
    </Section>
  );
};

export default PerformanceSummary;
